module.exports = __webpack_public_path__ + "static/media/timelify-extrabold.fce0e5ad.otf";